var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalPedTroRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63.867mm",
    height: "37.2mm",
    viewBox: "0 0 63.867 37.2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 104.69 37.546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 67.149 79.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4.2676,
    width: 140.6,
    height: 241.39,
    ry: 44.816
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.364 -8.4077)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-87.136 -68.563)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.749,
    cy: 95.571,
    r: 11.799,
    fill: "#f00",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.9052,36.772)",
    fill: "#280b0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.832 53.592c-0.58431 0-1.068-0.48231-1.068-1.0928 0-0.58429 0.48368-1.0666 1.068-1.0666 0.60907 0 1.0914 0.48231 1.0914 1.0666 0 0.61047-0.48234 1.0928-1.0914 1.0928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.407 59.231 0.12539-2.6169v2.8456c0 0.40514 0.20397 0.68488 0.58568 0.68488 0.38034 0.02619 0.6091-0.27974 0.6091-0.68488v-3.277c0-0.33073-0.27974-1.0928-0.73726-1.5503-0.43132-0.43133-1.0666-0.50712-1.3712-0.5581-0.25493-0.05099-0.5085-0.07579-0.76205-0.07579s-0.5085 0.02479-0.78687 0.07579c-0.27972 0.05098-0.9398 0.12678-1.3725 0.5581-0.45612 0.45751-0.71107 1.2196-0.71107 1.5503l-0.02487 3.277c0 0.40514 0.22876 0.71107 0.6091 0.68488 0.40651 0 0.58428-0.27974 0.58428-0.68488v-2.8456l0.12679 2.6169v6.2218c0 0.40652 0.33073 0.71245 0.71107 0.71245 0.38172 0 0.68625-0.30592 0.68625-0.71245v-6.1212h0.35555v6.1212c0 0.40652 0.30454 0.71245 0.68487 0.71245 0.40791 0 0.68765-0.30592 0.68765-0.71245v-6.2218"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.277 -8.4077)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-87.136 -68.563)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.749,
    cy: 95.571,
    r: 11.799,
    fill: "#f00",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.9052,36.772)",
    fill: "#280b0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.832 53.592c-0.58431 0-1.068-0.48231-1.068-1.0928 0-0.58429 0.48368-1.0666 1.068-1.0666 0.60907 0 1.0914 0.48231 1.0914 1.0666 0 0.61047-0.48234 1.0928-1.0914 1.0928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.407 59.231 0.12539-2.6169v2.8456c0 0.40514 0.20397 0.68488 0.58568 0.68488 0.38034 0.02619 0.6091-0.27974 0.6091-0.68488v-3.277c0-0.33073-0.27974-1.0928-0.73726-1.5503-0.43132-0.43133-1.0666-0.50712-1.3712-0.5581-0.25493-0.05099-0.5085-0.07579-0.76205-0.07579s-0.5085 0.02479-0.78687 0.07579c-0.27972 0.05098-0.9398 0.12678-1.3725 0.5581-0.45612 0.45751-0.71107 1.2196-0.71107 1.5503l-0.02487 3.277c0 0.40514 0.22876 0.71107 0.6091 0.68488 0.40651 0 0.58428-0.27974 0.58428-0.68488v-2.8456l0.12679 2.6169v6.2218c0 0.40652 0.33073 0.71245 0.71107 0.71245 0.38172 0 0.68625-0.30592 0.68625-0.71245v-6.1212h0.35555v6.1212c0 0.40652 0.30454 0.71245 0.68487 0.71245 0.40791 0 0.68765-0.30592 0.68765-0.71245v-6.2218"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalPedTroRed);
export default __webpack_public_path__ + "static/media/signal_ped_tro_red.fa9215784c86e89cfd19967edfbbd24b.svg";
export { ForwardRef as ReactComponent };